import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { 
    hideCustomMessage
} from '../actions/popupMessageActions';

class PopupCustomMessage extends Component {
    state = {  }
    hideModal = (e) => {
        this.setState({
            hideLabels: true
        }, () => {
            this.props.hideCustomMessage()
            setInterval(() => { 
                this.setState({
                    hideLabels: false
                })
            }, 2000);
            
        })
    }
    render() { 
        return ( 
            <React.Fragment>
                <Modal
                    id="popup-custommessage"
                    show={this.props.popupMessage.customModalConfig.showCustom}
                    onHide={this.hideModal.bind(this)}
                    dialogClassName="modal-90w"
                    aria-labelledby="example-custom-modal-styling-title"
                    centered
                >
                    <Modal.Header closeButton>
                        <h5 className="mb-0"><img src={process.env.PUBLIC_URL + '/images/info.png'} /> Info</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <center><label style={{whiteSpace: 'pre-line'}}>{this.props.popupMessage.customModalConfig.message}</label></center>
                        </div>
                    </Modal.Body>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    popupMessage: state.popupMessage
});

export default connect(mapStateToProps, { hideCustomMessage })(PopupCustomMessage);